// The rollout gate for the observation interview (the Observation Program page
// and OP Chat): the observation-program license module and the
// observation-program flag (FF_OBSERVATION_PROGRAM without PostHog). The OP
// Dashboard is not gated, only kept to admins. These pages are deep-linkable,
// so a closed gate redirects home, but only once its answers are in, since the
// gate is fail-closed while they load; until then it shows the page loader.
// Same shape as SmartCrGate.

import React, { ReactNode, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useObservationInterviewGate } from "src/helpers/licensedRolloutGates";
import AtomAssistPageLoad from "src/views/assistant/components/AtomAssistPageLoad";

const InterviewGate = ({ children }: { children: ReactNode }) => {
  // Read as the gate renders, so building the route table never calls the hook.
  const { enabled, loaded } = useObservationInterviewGate();
  const history = useHistory();

  useEffect(() => {
    if (loaded && !enabled) history.replace("/");
  }, [loaded, enabled, history]);

  if (enabled) return <>{children}</>;
  return loaded ? null : <AtomAssistPageLoad />;
};

/** Wraps an observation-interview route component in the license and flag
 * gate (src/routes.jsx). */
export const withObservationInterviewGate = <P extends object>(
  Component: React.ComponentType<P>,
): React.ComponentType<P> => {
  const Gated = (props: P) => (
    <InterviewGate>
      <Component {...props} />
    </InterviewGate>
  );
  Gated.displayName = `withObservationInterviewGate(${
    Component.displayName || Component.name || "Component"
  })`;
  return Gated;
};
